<template>
    <div class="changepwd-dialog">
        <el-dialog
            class="el-dialog-contain prop"
            title="密码过期提示"
            :visible.sync="confirmDialog"
            width="780px"
            :show-close="false"
            :close-on-press-escape="false"
            :close-on-click-modal="false"
        >
            <div class="confirm-container confirm-order-text">
                {{ title }}
            </div>
            <div class="button-container">
                <div style="margin: 0 auto">
                    <div class="btn-confirm" v-on:click="toOpenPage">确定</div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import Router from "@/router";
export default {
    data() {
        return {
            confirmDialog: false,
            title: "",
            message: ""
        };
    },
    created() {},
    methods: {
        openDialog() {
            this.confirmDialog = true;
            const userOtherInfo = this.$cache.getUserOtherInfo();
            this.title =
                "您的" +
                (userOtherInfo.specialflag == 1
                    ? "交易"
                    : userOtherInfo.specialflag == 2
                    ? "登录"
                    : userOtherInfo.specialflag == 3
                    ? "登录密码和交易"
                    : "") +
                "密码已过期，请立即修改！";
        },
        toOpenPage() {
            const userOtherInfo = this.$cache.getUserOtherInfo();
            // 需要强制修改交易密码、登录密码
            const isTradePwd = userOtherInfo.specialflag == "1" || userOtherInfo.specialflag == "3";
            this.confirmDialog = false;
            if (isTradePwd) {
                Router.push({ name: "changetpwd" });
            } else {
                Router.push({ name: "changelpwd" });
            }
        },
        closeDialog() {
            this.confirmDialog = false;
        }
    }
};
</script>

<style lang="scss" scoped>
.confirm-container {
    width: 92%;
    margin: 0 auto;
    height: auto;
}
::v-deep .el-dialog__header {
    color: #000;
    background-color: #eeeeee;
    font-weight: bold;
}
.confirm-order-text {
    font-family: Source Han Sans CN, sans-serif;
    font-size: 20px;
    line-height: 40px;
    letter-spacing: 0px;
    text-align: center;
    margin: 39.74px 20px 20px;
    color: $bg18;
}
.button-container {
    width: 100%;
    text-align: center;
    .btn-confirm {
        display: inline-block;
        color: #fff;
        background-color: $bg18;
        width: 180px;
        margin: 30px auto 10px;
        padding: 10px 0;
        text-align: center;
        font-size: 16px;
        margin-right: 40px;
        cursor: pointer;
        &:hover {
            opacity: 0.7;
        }
    }
    .cancel {
        color: #333;
        background: #e4e4e4;
    }
}
.confirm-btn {
    display: flex;
}
</style>
